module.exports = __webpack_public_path__ + "static/media/Rakett.b1603a23.m4a";